import { FloatingImageWithTextProps } from "~/components/FloatingImageWithText/FloatingImageWithText";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { ImageWithFloatedTextContentBlock } from "~/types/asgard/PostContentBlock";

export const apiToFloatingImageWithTextProps = ({
  floated_text,
  float_direction,
  floated_image,
  floated_image_caption,
  mobile_image,
}: ImageWithFloatedTextContentBlock): FloatingImageWithTextProps => ({
  bodyText: heDecodeOrDefault(floated_text),
  imageAlt: heDecodeOrDefault(floated_image.alt_text),
  imageCaption: heDecodeOrDefault(floated_image_caption),
  imageFloatDirection: float_direction,
  imageSrc: heDecodeOrDefault(floated_image.sizes.full.source_url),
  mobileImageSrc: heDecodeOrDefault(mobile_image?.sizes?.full.source_url),
  imageHeight: floated_image.sizes.full.height,
  imageWidth: floated_image.sizes.full.width,
});
